import React from 'react';

const SearchButtonArea = ({ children }) => {
    return <div className="filter-function">{children}</div>;
};

export default SearchButtonArea;
